import './news-filter.scss';

class NewsFilter {
    constructor ($element) {
        this.$newsFilter = $element;
        this.$filterForm = this.$newsFilter.querySelector('[data-news-overview-filter="form"]');
        this.$$filterOptions = this.$newsFilter.querySelectorAll('[data-news-category-id]');
        this.selectedOptions = [];

        this.initialize();
    }

    initialize () {
        this.$$filterOptions.forEach($filterOption => {
            // init call
            this.mapFilterOptions($filterOption);

            // onchange
            $filterOption.onchange = () => {
                this.mapFilterOptions($filterOption);
            };
        });

        this.$filterForm.onsubmit = (e) => {
            e.preventDefault();

            if (this.selectedOptions.length > 0) {
                window.location.href = `${this.$filterForm.dataset.newsFilterAction}?c=${this.selectedOptions.join(',')}`;
            } else {
                window.location.href = this.$filterForm.dataset.newsFilterAction;
            }
        };
    }

    mapFilterOptions (filterOption) {
        const categoryId = filterOption.dataset.newsCategoryId;

        if (filterOption.checked) {
            if (!this.selectedOptions.includes(categoryId)) {
                this.selectedOptions.push(categoryId);
            }
        } else {
            this.selectedOptions = this.selectedOptions.filter(option => option !== categoryId);
        }
    }
}

export { NewsFilter };

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const $context = eventDetails.$context;

    const $$newsFilter = $context.querySelectorAll('[data-news-overview-filter="root"]');

    if ($$newsFilter.length > 0) {
        $$newsFilter.forEach(($newsFilter) => {
            const newsFilter = new NewsFilter($newsFilter); // eslint-disable-line
        });
    }
});